import { OpenInFull } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { AdditionalInfoForm, FormCard } from '@/components';

import { FormItemRoot, LiveInformationRoot } from '../styles';

export const LiveInformation = () => {
  return (
    <LiveInformationRoot>
      <FormCard
        title="Live information"
        classes={{
          cardContainer: 'live-info-card-container',
          cardContent: 'live-info-card-content',
        }}
      >
        <FormItemRoot>
          <>
            <IconButton
              sx={{ position: 'absolute', right: 10, top: 8 }}
              onClick={() => {}}
            >
              <OpenInFull fontSize="small" />
            </IconButton>
          </>
          <AdditionalInfoForm
            cfsId={undefined}
            additionalInfoList={undefined}
            onSubmit={() => {}}
            setNewAdditionalInfo={() => {}}
            isFirstResponderView={false}
            disableSendMessage={false}
            isFirstResponderModal={false}
            maxChars={1500}
            mirrorOffsetX={-2}
          />
        </FormItemRoot>
      </FormCard>
    </LiveInformationRoot>
  );
};
